<template>
  <div class="box">
    <div
      class="login-left"
      style="background-image: url('http://cdn.yxvzb.com/WEB/SaaS/images/login-bg-gys.png');background-size: 100% 100%;background-repeat: no-repeat;height: 100vh"
    ></div>
    <div class="login-right">
      <div
        class="logo-image-bar"
        style="background-image: url('http://cdn.yxvzb.com/WEB/SaaS/images/cso.png');background-size: 100% 100%;background-repeat: no-repeat;width: 352px;height: 55px"
      ></div>
      <div class="login">
        <div v-if="showTab" class="login-tab">
          <div
            @click="forUse = 'formInline'"
            :class="{ picked: forUse !== 'passwordForm' }"
          >
            手机登录
          </div>
          <div
            id="loginByPassword"
            @click="forUse = 'passwordForm'"
            :class="{ picked: forUse === 'passwordForm' }"
          >
            密码登录
          </div>
        </div>
        <div v-else class="login-tab">
          <div class="picked" v-if="findText">{{ findText }}</div>
          <!--找回密码-->
        </div>
        <!--验证码登录-->
        <el-form
          v-show="forUse === 'formInline' || forUse === 'forget'"
          ref="formInline"
          class="login-form"
          :model="formInline"
          :rules="ruleInline"
        >
          <el-form-item prop="phone">
            <el-input
              v-model.trim="formInline.phone"
              placeholder="输入手机号"
              clearable
            />
          </el-form-item>
          <!--          <el-form-item prop="imgVerifyCode" v-show="showFlag" class="quaBox">-->
          <!--            <el-input-->
          <!--              v-model="formInline.imgVerifyCode"-->
          <!--              placeholder="输入图形验证码"-->
          <!--              clearable-->
          <!--              class="login-input"-->
          <!--              autocomplete="off"-->
          <!--            />-->
          <!--            <img v-if="imgUrl" :src="imgUrl" class="imgVerify" @click="changeEwm">-->
          <!--            <img v-else class="imgVerify" src="" alt="验证码未获取">-->
          <!--          </el-form-item>-->
          <el-form-item prop="verifyCode" class="quaBox">
            <el-input
              v-model="formInline.verifyCode"
              placeholder="输入验证码"
              clearable
              class="login-input"
            />
            <XrkSlideVerify
              ref="verification"
              :options="verificationOptions"
              @success="checkSuccessful"
              @close="verifyClose"
            >
              <el-button
                class="login-bts2"
                @click="showVerification"
                :disabled="sendLock"
                :loading="ifBtnLoad"
              >
                {{ sendText }}
              </el-button>
            </XrkSlideVerify>
          </el-form-item>
          <el-checkbox v-model="allowFlag" class="login-check">
            <span style="color:#666666;">我同意遵守</span>
            <span
              @click.prevent="showProtocol = true"
              style="color:#1989FA;cursour:pointer"
            >
              《向日葵平台服务协议》
            </span>
          </el-checkbox>
          <!--确定内容-->
          <template v-if="forUse === 'formInline'">
            <el-button
              type="primary"
              class="login-bts"
              :disabled="!allowFlag"
              @click="reg"
              :loading="ifBtnLoad"
            >
              立即登录
            </el-button>
          </template>
          <div class="login-button-container" v-else-if="forUse === 'forget'">
            <el-button
              @click="pre"
              style="border-color:rgba(147,183,248,1);color: rgba(147,183,248,1)"
              :disabled="!allowFlag"
              :loading="ifBtnLoad"
            >
              取消
            </el-button>
            <el-button
              type="primary"
              @click="reg"
              :disabled="!allowFlag"
              :loading="ifBtnLoad"
            >
              下一步
            </el-button>
          </div>
        </el-form>
        <!--密码登录-->
        <el-form
          v-show="forUse === 'passwordForm'"
          class="login-form"
          ref="passwordForm"
          :model="passwordForm"
          :rules="accountRules"
        >
          <el-form-item prop="phone" style="margin-bottom:30px">
            <el-input
              id="loginByPassword_account"
              v-model.trim="passwordForm.phone"
              placeholder="请输入账号名称"
              clearable
            />
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              id="loginByPassword_password"
              v-model.trim="passwordForm.password"
              placeholder="请输入账号密码"
              clearable
              maxlength="16"
              @keydown.native.enter="passwordReg"
              type="password"
            />
            <div class="forget-button" @click="forUse = 'forget'">
              忘记密码?
            </div>
          </el-form-item>
          <el-checkbox v-model="allowFlag" class="login-check">
            <span style="color:#666666;">我同意遵守</span>
            <span
              @click.prevent="showProtocol = true"
              style="color:#1989FA;cursour:pointer"
            >
              《向日葵平台服务协议》
            </span>
          </el-checkbox>
          <el-button
            id="submit"
            type="primary"
            class="login-bts"
            :disabled="!allowFlag"
            @click="passwordReg"
            :loading="ifBtnLoad"
          >
            立即登录
          </el-button>
        </el-form>
        <!-- 重置密码-->
        <el-form
          v-if="forUse === 'resetForm'"
          class="login-form"
          ref="resetForm"
          :model="resetForm"
          :rules="ruleInline"
        >
          <el-form-item prop="password">
            <el-input
              v-model.trim="resetForm.password"
              placeholder="请输入新密码"
              clearable
              maxlength="16"
              type="password"
            />
          </el-form-item>
          <el-form-item prop="confirm">
            <el-input
              v-model.trim="resetForm.confirm"
              placeholder="请再次输入密码"
              clearable
              maxlength="16"
              type="password"
            />
          </el-form-item>
          <el-checkbox v-model="allowFlag" class="login-check">
            <span style="color:#666666;">我同意遵守</span>
            <span
              @click.prevent="showProtocol = true"
              style="color:#1989FA;cursour:pointer"
            >
              《向日葵平台服务协议》
            </span>
          </el-checkbox>
          <div class="login-button-container">
            <el-button
              type="primary"
              @click="pre"
              :disabled="!allowFlag"
              :loading="ifBtnLoad"
            >
              上一步
            </el-button>
            <el-button
              type="primary"
              @click="next"
              :disabled="!allowFlag"
              :loading="ifBtnLoad"
            >
              下一步
            </el-button>
          </div>
        </el-form>
        <div v-if="forUse === 'success'" class="success-container">
          <img src="http://cdn.yxvzb.com/WEB/SaaS/images/登录成功.png" />
          <div class="success-inside-title">重置密码成功</div>
          <div class="success-inside-text">
            <p>密码设置成功,{{ count }}秒后将直接登录</p>
            <p>
              若无反应点击进入
              <span class="like-a" @click="jumpHome('now')">首页</span>
            </p>
          </div>
        </div>
        <Protocol v-if="showProtocol" @close="closeProtocol"></Protocol>
      </div>
      <div style="height: 1px"></div>
    </div>
    <div class="toast" v-show="showToast > 0">
      <div class="toastTit" v-if="showToast == 1">
        您还未完成企业认证，请前往
        <br />
        “向日葵学术服务众包B2B平台”
        <br />
        完成企业认证。
      </div>
      <div v-else class="toastTit">
        您还未签约《向日葵平台服务
        <br />
        框架合同》，请前往”向日葵学术
        <br />
        服务众包B2B平台“签约该合同。
      </div>
      <div class="toastBtn">
        <el-button type="primary" class="cancel" @click="cancel">
          取消
        </el-button>
        <el-button type="primary" v-if="showToast == 1" @click="goSun(1)">
          前往认证
        </el-button>
        <el-button type="primary" v-else @click="goSun(2)">前往签约</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { setStorage, getStorage } from '@/tools/storage';
import { getVerification, login } from '@/api/ajax';
import { mapActions } from 'vuex';
import Protocol from './components/Protocol';
import createExtend from '@C/createExtend';
import resetPasswordDialog from './components/resetPasswordDialog.vue';
import { checkV3NoSigned } from '../../methods/check';

export default {
  computed: {
    showTab() {
      switch (this.forUse) {
        case 'passwordForm':
        case 'formInline':
          return true;
        case 'forget':
          this.findText = '验证手机号';
          return false;
        case 'resetForm':
          this.findText = '重置密码';
          return false;
        case 'success':
          this.findText = '';
          return false;
        default:
          return true;
      }
    }
  },
  components: {
    Protocol,
    theVerification: () => import('@/components/verification')
  },
  data() {
    const validatePhone = (rule, value, callback) => {
      if (!/^1\d{10}$/.test(value)) {
        callback(new Error('请输入正确的手机号'));
      } else {
        callback();
      }
    };
    const validateAccount = (rule, value, callback) => {
      var reg = /[^\u4e00-\u9fa5A-Za-z0-9_{}()（）【】[\]-]/;
      if (reg.test(value)) {
        callback(new Error('请输入中文、英文、数字、下划线、横线、括号'));
      } else if (value == '') {
        callback(new Error('请输入账号名称'));
      } else if (value.length > 50) {
        callback(new Error('账号名称长度不能超过50'));
      } else {
        callback();
      }
      // if (!/^[a-zA-Z][a-zA-Z0-9_]{4,15}$/.test(value)) {
      // if (value.length < 0 || value.length > 20) {
      //   callback(
      //     // new Error('账号名称不符合规则：4到15位数字字母下划线组成，字母开头）')
      //     new Error('请输入20位以内的字符')
      //   );
      // } else {
      //   callback();
      // }
    };
    const validateVerifyCode = (rule, value, callback) => {
      if (!this.checkVerify) {
        callback();
      } else {
        if (value) {
          callback();
        } else {
          callback(new Error('短信验证码不正确'));
        }
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (this.forUse == 'passwordForm') {
        if (value == '') {
          callback(new Error('请填写密码'));
        } else {
          callback('');
        }
      } else {
        if (!/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{4,16}$/.test(value)) {
          callback(new Error('密码只能使用数字和字母组合,4到16位'));
        } else {
          callback('');
        }
      }
    };
    const validateComfirm = (rule, value, callback) => {
      if (!/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{4,16}$/.test(value)) {
        callback(new Error('只能使用4到16位数字和字母组合'));
      } else if (this.resetForm.password !== value) {
        callback(new Error('请填写相同的密码'));
      } else {
        callback('');
      }
    };
    return {
      verificationOptions: {
        // 接口请求 防抖
        remoteTimerInterval: 800,
        errorText: '请控制拼图块对齐缺口',
        successText: '验证成功',
        remoteApi: {
          initImages: getVerification,
          checkVerification: position => {
            return login.sendMessageCode({ ...this.formInline, ...position });
          }
        },
        errorAnimationDuration: 800
      },
      showToast: 0,
      count: 5,
      findText: '验证手机号',
      setTime: null,
      forUse: 'formInline',
      passwordForm: {
        phone: '',
        password: ''
      },
      resetForm: {
        phone: '',
        verifyCode: '',
        password: '',
        confirm: ''
      },
      showProtocol: false,
      ifBtnLoad: false,
      timer: null,
      imgUrl: '', //图形验证码
      showFlag: false,
      formInline: {
        phone: '',
        // imgVerifyCode: "",
        verifyCode: ''
      },
      sendLock: false,
      sendText: '获取验证码',
      checkVerify: false, //是否校验短信码
      accountRules: {
        phone: [{ validator: validateAccount, trigger: 'blur' }],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
          {
            required: true,
            validator: validatePassword
          }
        ]
      },
      ruleInline: {
        phone: [{ validator: validatePhone, trigger: 'blur' }],
        // imgVerifyCode: [
        //   { required: true, message: "图片验证码不能为空", trigger: "blur" }
        // ],
        confirm: [
          { required: true, message: '确认密码不能为空', trigger: 'blur' },
          { trigger: 'blur', validator: validateComfirm }
        ],
        // 要写必要的验证
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
          {
            required: true,
            validator: validatePassword
          }
        ],
        verifyCode: [{ validator: validateVerifyCode, trigger: 'blur' }]
      },
      phoneNum: '',
      quaNum: '',
      allowFlag: true
    };
  },
  methods: {
    ...mapActions(['InitUser']),
    cancel() {
      this.showToast = 0;
    },
    goSun(type) {
      let host = '';
      if (/192.168|jimijiayuan/.test(location.href)) {
        host = 'http://saas-sun-pc.jimijiayuan.cn';
      } else {
        host = 'http://saas-sun-pc.myxrk.com';
      }
      if (type == 1) {
        location.href = `${host}/auth.html`;
      } else {
        location.href = `${host}/user.html`;
      }
    },
    test() {
      this.$message.error('密码修改失败');
    },
    directLogin() {
      login
        .passwordLogin(this.mycash)
        .then(res => {
          let check = res.data.data.moreStatus;
          if (
            check.enterpriseAuthStatus == 0 &&
            check.v3EnterpriseAuthStatus == 0
          ) {
            this.showToast = 1;
          } else if (check.frameAgreementStatus == 0) {
            this.showToast = 2;
          } else {
            this.InitUser(res.data.data).then(() => {
              this.$router.push({
                name: 'home'
              });
            });
          }
        })
        .catch(e => {
          console.error('密码登录出错', e);
        });
    },
    jumpHome(str) {
      this.count = 5;
      if (str === 'now') {
        try {
          if (this.setTime) {
            clearInterval(this.setTime);
          }
          this.directLogin();
        } catch (e) {}
        return;
      }
      this.setTime = setInterval(() => {
        this.count--;
        if (this.count === 0) {
          clearInterval(this.setTime);
          this.directLogin();
          // this.$router.replace('/home')
        }
      }, 1000);
    },
    pre() {
      this.forUse = 'formInline';
    },
    next() {
      this.$refs['resetForm'].validate(valid => {
        if (valid) {
          //  验证登录
          let password = this.resetForm.password;
          let confirm = this.resetForm.confirm;
          let pass = Object.assign({}, this.resetForm, { password, confirm });
          login.resetUserPwd(pass).then(res => {
            this.mycash = Object.assign({}, pass);
            if (res.data.status == 1) {
              this.forUse = 'success';
              this.jumpHome();
            } else {
              this.$message.error('密码修改失败');
            }
          });
        } else {
        }
      });
    },

    changeEwm() {
      //更换二维码
      if (this.forUse === 'forget') {
        this.imgUrl = `${login.verifyImgCode}?phone=${
          this.formInline.phone
        }&v=${+new Date()}`;
      } else {
        this.imgUrl = `${login.verifyImgCode}?phone=${
          this.formInline.phone
        }&v=${+new Date()}`;
      }
    },
    reg() {
      //验证码登录
      this.checkVerify = true;
      if (this.forUse === 'forget') {
        //忘记密码 验证手机号
        this.$refs['formInline'].validate(valid => {
          if (valid) {
            login
              .validatePhoneAndSmscodeForResetPassword(this.formInline)
              .then(res => {
                if (res.data.status == 1) {
                  Object.assign(this.resetForm, this.formInline);
                  this.forUse = 'resetForm';
                } else {
                  this.$message.error('账号验证不通过');
                }
              });
          }
        });
      } else {
        this.$refs['formInline'].validate(valid => {
          if (valid) {
            login.login(this.formInline).then(res => {
              let check = res.data.data.moreStatus;
              if (
                check.enterpriseAuthStatus == 0 &&
                check.v3EnterpriseAuthStatus == 0
              ) {
                this.showToast = 1;
              } else if (check.frameAgreementStatus == 0) {
                this.showToast = 2;
              } else {
                this.InitUser(res.data.data).then(() => {
                  let showPsw = {
                    firstLog: res.data.data.firstLog, //firstLog 1首次登录 0非首次登录
                    initPwd: res.data.data.initPwd //initPwd 1设置密码 0修改密码
                  };
                  setStorage('showPs', showPsw);
                  if (res.data.data.firstLog == 1) {
                    this.improvePassword();
                    return;
                  }
                  this.$router.push({
                    name: 'home'
                  });
                  checkV3NoSigned();
                });
              }
            });
          }
        });
      }
    },
    passwordReg() {
      this.$refs['passwordForm'].validate(valid => {
        if (valid) {
          this.passwordForm.password = this.passwordForm.password;
          login
            .passwordLogin(this.passwordForm)
            .then(res => {
              let check = res.data.data.moreStatus;
              if (
                check.enterpriseAuthStatus == 0 &&
                check.v3EnterpriseAuthStatus == 0
              ) {
                this.showToast = 1;
              } else if (check.frameAgreementStatus == 0) {
                this.showToast = 2;
              } else {
                this.InitUser(res.data.data).then(() => {
                  this.$router.push({
                    name: 'home'
                  });
                  checkV3NoSigned();
                });
              }
            })
            .catch(e => {
              console.error('密码登录出错', e);
            });
        }
      });
    },
    showVerification() {
      //获取短信
      // this.checkVerify = false;
      // if (!this.sendLock) {
      this.$refs['formInline'].validate(valid => {
        if (!valid) return;
        this.sendLock = true;
        this.sendText = 60;
        this.$refs['verification'].visible = true;
      });
    },
    checkSuccessful() {
      this.timer = setInterval(() => {
        if (this.sendText > 0) {
          this.sendText -= 1;
        } else {
          clearInterval(this.timer);
          this.sendText = '获取验证码';
          this.sendLock = false;
        }
      }, 1000);
    },
    verifyClose() {
      clearInterval(this.timer);
      this.sendText = '获取验证码';
      this.sendLock = false;
    },
    closeProtocol() {
      this.showProtocol = false;
    },
    //完善密码
    improvePassword() {
      let resetPasswordDialogDom = createExtend(resetPasswordDialog, {
        cancelTexts: '跳过',
        titles: '完善密码',
        dialogVisibles: true
      });
      resetPasswordDialogDom.$on('confirm', async compRes => {
        let password = {
          password: compRes.resetForm.pass
        };
        try {
          await login.setUserPwd(password).then(async res => {
            if (res.data.status == '1') {
              let showPs = getStorage('showPs');
              showPs.initPwd = 0;
              setStorage('showPs', showPs);
              this.$message.success('设置密码成功！');
              await this.$router.push({
                name: 'home'
              });
              compRes.isShowDialog();
            } else {
              this.$message.error('设置密码失败');
            }
          });
        } catch (error) {
          compRes.showIsLoading();
        }
      });
      resetPasswordDialogDom.$on('skip', async () => {
        await this.$router.push({
          name: 'home'
        });
      });
      return;
    }
  },
  watch: {
    // 切换功能时候清理其他表格
    forUse(val) {
      let list = ['passwordForm', 'formInline', 'resetForm'];
      for (let item of list) {
        if (item !== val) {
          let target = this[item];
          for (let key of Object.keys(target)) {
            target[key] = '';
          }
        }
      }
    },
    'formInline.phone'(v) {
      if (/^1\d{10}$/.test(this.formInline.phone)) {
        this.changeEwm();
        this.showFlag = true;
      } else {
        this.showFlag = false;
      }
    }
  },
  created() {},
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
};
</script>
<style lang="scss" scoped>
.box {
  display: flex;
  min-width: 1200px;
  width: 100%;

  .login-left {
    width: 68%;
    /*display: inline-block;*/
    & > img {
      /*height: 100vh;*/
      width: 100%;
      height: auto;
    }
  }

  .login-right {
    /*z-index: 200;*/
    .logo-image-bar {
      padding: 10px;
      transform: translateX(-50px);
      width: 100%;
      /*z-index: 1200;*/
    }

    width: 32%;
    /*overflow: hidden;*/
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    background: rgba(255, 255, 255, 1);

    /*background: yellow;*/
  }

  .like-a {
    color: rgba(61, 127, 244, 1);
    cursor: pointer;
  }

  .blue-theme {
    color: rgba(61, 127, 244, 1);
  }

  .login {
    /*height: 500px;*/
    .success-container {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;

      & > img {
        width: 100%;
      }

      .success-inside-title {
        transform: translateY(-35px);
        margin-bottom: 30px;
        color: rgba(61, 127, 244, 1);
        font-size: 22px;
      }

      .success-inside-text {
        transform: translateY(-35px);

        & > p {
          text-align: center;
          font-size: 14px;
          line-height: 24px;
        }
      }
    }

    .login-tab {
      display: flex;
      justify-content: space-around;
      color: rgba(51, 51, 51, 1);
      font-size: 19px;
      /*display: flex;*/
      font-weight: bold;
      /*padding-bottom: 5px;*/
      cursor: pointer;

      .picked {
        color: rgba(61, 127, 244, 1);

        &::after {
          content: '';
          margin: 4px auto 20px;
          width: 30px;
          display: block;
          height: 0;
          border-radius: 2px;
          background: #3d7ff4;
          height: 4px;
        }
      }
    }

    .login-form {
      .login-button-container {
        /*background: yellow;*/
        display: flex;
        justify-content: space-between;

        & > button {
          width: 105px;
        }
      }

      > * {
        margin-bottom: 25px;
        position: relative;
      }

      .forget-button {
        position: absolute;
        right: 0;
        bottom: -1em;
        height: 1.3em;
        color: rgba(61, 127, 244, 1);
        cursor: pointer;
      }

      .login-input {
        width: 170px;
        margin-right: 5px;
        height: 40px;
      }

      .imgVerify {
        width: 140px;
        height: 40px;
      }

      .login-bts2 {
        width: 140px;
        height: 40px;
        border-radius: 2px;
        border-color: rgba(25, 137, 250, 1);
        color: #1989fa;
        display: inline-block;
      }

      .login-bts {
        width: 100%;
        height: 40px;
        font-size: 14px;
        border-radius: 2px;
      }

      .login-check {
        margin-top: 40px;
        margin-bottom: 18px;
        display: flex;
        align-items: center;
      }
    }
  }

  .quaBox {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
  .toast {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 444px;
    height: 276px;
    background: #fff;
    border-radius: 12px;
    padding: 43px 57px 30px;
    box-sizing: border-box;
    margin-left: -220px;
    margin-top: -138px;
    z-index: 10;
    .toastTit {
      font-size: 22px;
      line-height: 38px;
      color: #2e2f2f;
      text-align: center;
      margin-bottom: 10px;
    }
    .toastBtn {
      display: flex;
      justify-content: space-between;
      .cancel {
        color: #1989fa;
        background: #fff;
        border: 1px solid #1989fa;
      }
    }
  }
}
</style>
